<template>
  <div class="ns-map">
    <div class="logo"></div>
    <div class="map-c" :style="`transform: scale(${scale},${scale})`">
      <img :src="`images/map/${map}.jpg`"/>
      <a href="javascript:void(0);" class="point" :data-index="index" v-for="(item,index) in countries" :style="`left: ${item.x-6}px;top: ${item.y-5}px;`" @click="confirmCountry(item)"><span>{{item.name}}</span></a>
    </div>
    <div class="bottom">
      <div class="text">{{$t("map.desc")}}</div>
      <div class="btns" v-if="countries.length>0">
        <div class="item">
          <a href="javascript:void(0);" @click="selectCountry">
            <span>{{(currentCountry === '' ? '--' : currentCountry)}}</span>
          </a>
        </div>
        <div class="item">
          <a href="javascript:void(0);" :class="`${currentCountry===''?'dis':''}`" @click="join">{{$t("map.btn")}}</a>
        </div>
      </div>
    </div>
    <transition name="fade" :duration="200">
      <div class="selecter" v-if="showCountry">
        <div class="sc">
          <div class="title">
            {{$t("map.selectCountry")}}
          </div>
          <div class="list" :style="`max-height:${maxHeight}px;`">
            <a href="javascript:void(0);" @click="confirmCountry(item)" v-for="(item,index) in countries" :class="`${item.languages.length>1?'':'dis'}`">{{item.name}}</a>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade" :duration="200">
      <div class="selecter" v-if="showLanguage">
        <div class="sc">
          <div class="title">
            {{$t("map.selectLanguage")}}
          </div>
          <div class="list" :style="`max-height:${maxHeight}px;`">
            <a href="javascript:void(0);" @click="confirmLanguage(item)" v-for="(item,index) in languages" class="dis">{{item.name}}</a>
          </div>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "main-map",
  props: {
    autoCountry: {
      required: true,
      type: String,
      default: '中国'
    },
  },
  data() {
    return {
      /* currentCountry: "",
       currentCountryCode: "",*/
      currentCountry: "",
      currentCountryCode: "",
      currentCountryLanguage: [],
      scale: 1,
      map: 0,
      maxHeight: 0,
      showCountry: false,
      showLanguage: false,
      languages: [],
      countries: [
        {
          chName: "中国",
          x: 809, y: 478,
          tz: 8, code: "CHN", id: 1, name: "中国", languages: [
            {local: 'zh', name: ''}
          ]
        },
        {
          chName: "韩国",
          x: 859, y: 470, tz: 9, code: "KOR", id: 2, name: "대한민국", languages: [
            {local: 'ko', name: ''}
          ]
        },
        {
          chName: "日本",
          x: 895, y: 471, tz: 9, code: "JPN", id: 3, name: "日本", languages: [
            {local: 'ja', name: ''}
          ]
        },
        {
          chName: "泰国",
          x: 766, y: 549, tz: 7, code: "THA", id: 4, name: "Thailand", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "新加坡",
          x: 772, y: 594, tz: 8, code: "SGP", id: 5, name: "Singapore", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "尼泊尔",
          x: 705, y: 503, tz: 5, code: "NPL", id: 6, name: "Nepal", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "哈萨克斯坦",
          x: 645, y: 433, tz: 6, code: "KAZ", id: 7, name: "Kazakhstan", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "蒙古",
          x: 777, y: 440, tz: 8, code: "MNG", id: 8, name: "Mongolia", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "斯里兰卡",
          x: 692, y: 573, tz: 5, code: "LKA", id: 9, name: "Sri Lanka", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "老挝",
          x: 776, y: 533, tz: 7, code: "LAO", id: 10, name: "Laos", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "巴基斯坦",
          x: 650, y: 496, tz: 5, code: "PAK", id: 11, name: "Pakistan", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "柬埔寨",
          x: 778, y: 554, tz: 7, code: "KHM", id: 12, name: "Cambodia", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "越南",
          x: 792, y: 558, tz: 7, code: "VNM", id: 13, name: "Vietnam", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "缅甸",
          x: 744, y: 521, tz: 6, code: "MMR", id: 14, name: "Myanmar", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "以色列",
          x: 527, y: 486, tz: 2, code: "ISR", id: 15, name: "Israel", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "印度",
          x: 684, y: 526, tz: 5, code: "IND", id: 16, name: "India", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "马来西亚",
          x: 766, y: 581, tz: 8, code: "MYS", id: 17, name: "Malaysia", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "俄罗斯",
          x: 794, y: 388, tz: 7, code: "RUS", id: 18, name: "Russia", languages: [
            {local: 'ru', name: ''}
          ]
        },
        {
          chName: "德国",
          x: 440, y: 419, tz: 1, code: "DEU", id: 19, name: "Germany", languages: [
            {local: 'de', name: ''}
          ]
        },
        {
          chName: "法国",
          x: 412, y: 434, tz: 1, code: "FRA", id: 20, name: "France", languages: [
            {local: 'fr', name: ''}
          ]
        },
        {
          chName: "西班牙",
          x: 392, y: 456, tz: 1, code: "ESP", id: 21, name: "Spain", languages: [
            {local: 'es', name: ''}
          ]
        },
        {
          chName: "英国",
          x: 399, y: 407, tz: 0, code: "GBR", id: 22, name: "The United Kingdom", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "意大利",
          x: 448, y: 449, tz: 1, code: "ITA", id: 23, name: "Italy", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "匈牙利",
          x: 475, y: 431, tz: 1, code: "HUN", id: 24, name: "Hungary", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "马耳他",
          x: 455, y: 474, tz: 1, code: "MLT", id: 25, name: "Malta", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "丹麦",
          x: 435, y: 399, tz: 1, code: "DNK", id: 26, name: "Denmark", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "比利时",
          x: 420, y: 418,
          tz: 1, code: "BEL", id: 27, name: "Belgium", languages: [
            {local: 'en', name: 'English'},
            {local: 'fr', name: 'Français'},
          ]
        },
        {
          chName: "瑞典",
          x: 466, y: 374, tz: 1, code: "SWE", id: 28, name: "Sweden", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "希腊",
          x: 486, y: 470, tz: 2, code: "GRC", id: 29, name: "Greece", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "荷兰",
          x: 424, y: 409, tz: 1, code: "NLD", id: 30, name: "Netherlands", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "白俄罗斯",
          x: 508, y: 409, tz: 2, code: "BLR", id: 31, name: "Belarus", languages: [
            {local: 'ru', name: ''}
          ]
        },
        {
          chName: "保加利亚",
          x: 494, y: 449, tz: 2, code: "BGR", id: 32, name: "Bulgaria", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "拉脱维亚",
          x: 495, y: 396, tz: 2, code: "LVA", id: 33, name: "Latvia", languages: [
            {local: 'en', name: ''}
          ]
        }, //这里有问题,后修复, 名称问题, 改英语
        {
          chName: "罗马尼亚",
          x: 496, y: 435, tz: 2, code: "ROU", id: 34, name: "Romania", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "卢森堡",
          x: 427, y: 423,
          tz: 1, code: "LUX", id: 35, name: "Luxembourg", languages: [
            {local: 'de', name: 'Deutsch'},
            {local: 'fr', name: 'Français'},
            {local: 'en', name: 'English'},
          ]
        },
        {
          chName: "塞尔维亚",
          x: 479, y: 443, tz: 1, code: "SRB", id: 36, name: "Serbia", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "瑞士",
          x: 433, y: 431,
          tz: 1, code: "CHE", id: 37, name: "Schweizerische Eidgenossenschaft", languages: [
            {local: 'de', name: 'Deutsch'},
            {local: 'fr', name: 'Français'},
            {local: 'en', name: 'English'},
          ]
        },
        {
          chName: "墨西哥",
          x: 1318, y: 515, tz: -6, code: "MEX", id: 38, name: "Mexico", languages: [
            {local: 'es', name: ''}
          ]
        },
        {
          chName: "澳大利亚",
          x: 888, y: 689, tz: 10, code: "AUS", id: 39, name: "Australia", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "新西兰",
          x: 1010, y: 757, tz: 12, code: "NZL", id: 40, name: "New Zealand", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "斐济",
          x: 1038, y: 664, tz: 12, code: "FJI", id: 41, name: "Fiji", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "贝宁",
          x: 415, y: 569, tz: 1, code: "BEN", id: 42, name: "Benin", languages: [
            {local: 'fr', name: ''}
          ]
        },
        {
          chName: "毛里求斯",
          x: 613, y: 674, tz: 4, code: "MUS", id: 43, name: "Mauritius", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "埃及",
          x: 514, y: 511, tz: 2, code: "EGY", id: 44, name: "Egypt", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "尼日利亚",
          x: 436, y: 569, tz: 1, code: "NGA", id: 45, name: "Nigeria", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "坦桑尼亚",
          x: 529, y: 629, tz: 3, code: "TZA", id: 46, name: "Tanzania", languages: [
            {local: 'en', name: ''}
          ]
        },
        {
          chName: "摩洛哥",
          x: 380, y: 487, tz: 1, code: "MAR", id: 47, name: "Morocco", languages: [
            {local: 'fr', name: ''}
          ]
        },//47
      ],
      list: [],
      pm: {}
    }
  },
  created() {

    var self = this;


    //var now = moment("2020-10-03T12:00:00Z").utc();
    //var now = moment("2020-09-29 20:05:00").utc();
    var now = moment().utc();
    //var to = moment("2020-09-29T12:00:00Z").utc();   //当达到这个时间时  东12区就可以点亮了
    var to = moment("2020-09-29T20:00:00").utc();   //当达到这个时间时  东12区就可以点亮了
    var diff = now.diff(to, "hours");         //这俩相减 ==0 就点亮 东十二
    //var diff_s = now.diff(to, "seconds");         //这俩相减 ==0 就点亮 东十二


    /*    var now = moment().utc();
        //var now = moment().utc();
        var to = moment("2020-09-28T10:00:00Z").utc();   //当达到这个时间时  东12区就可以点亮了
        var diff = now.diff(to, "hours");         //这俩相减 ==0 就点亮 东十二*/

    this.map = (diff < 0 ? 0 : diff < 24 ? diff + 1 : 24) + "_";


    $.post("https://static.3rdplanet.com.cn/api/index.php?con=Index&action=getArea", {}, function (data) {
      var autoCountry = data.data.country;
      if (!autoCountry || autoCountry === '') {
        autoCountry = "中国";
      }

      var find = false;
      /*if (diff >= 0) {
        self.countries.forEach((item) => {
          /!*if (diff >= Math.abs(item.tz - 12)) {
            self.list.push(item);
          }*!/
          self.list.push(item);
        });
        self.list.forEach((item) => {
          if (item.chName === autoCountry) {
            find = true;
            self.currentCountry = item.name;
            self.currentCountryCode = item.code;
            self.$i18n.locale = item.languages[0].local;
          }
        });
      }*/

      self.countries.forEach((item) => {
        /*if (diff >= Math.abs(item.tz - 12)) {
          self.list.push(item);
        }*/
        //self.list.push(item);
      });
      self.countries.forEach((item) => {
        if (item.chName === autoCountry) {
          find = true;
          self.currentCountry = item.name;
          self.currentCountryCode = item.code;
          self.$i18n.locale = item.languages[0].local;
        }
      });

      //alert(find)
      if (!find) {
        self.currentCountry = "中国";
        self.currentCountryCode = "CHN";
        self.$i18n.locale = "zh";
        /* if (self.list.length > 0) {
           self.currentCountry = self.list[0].name;
           self.currentCountryCode = self.list[0].code;
           self.$i18n.locale = self.list[0].languages[0].local;

         } else {
           self.currentCountry = "";
           self.currentCountryCode = "";
           self.$i18n.locale = "en";
         }*/
      }


      return false;
    }, "json");

    /*if (!this.autoCountry || this.autoCountry === '') {
      this.autoCountry = '中国';
    }*/

    //console.log("获取的位置" + this.autoCountry);

    $(document).on("mouseover", ".point", this.pointMouesOver);
    $(document).on("mouseout", ".point", this.pointMouesOut);

    //this.map = 25;

    /*  console.log(to.format());
      console.log(now.format());
      console.log();*/
  }
  ,
  methods: {
    pointMouesOver(e) {
      //$(".point span").removeClass("ani");
      //$(".point span").removeClass("show");
      //console.log(1);
      clearTimeout(this.pm[$(e.target).attr("data-index")]);
      $(e.target).find("span").addClass("show");
      setTimeout(() => {
        $(e.target).find("span").addClass("ani");
      }, 50);
    },
    pointMouesOut(e) {
      //console.log(2);
      $(e.target).find("span").removeClass("ani");
      this.pm[$(e.target).attr("data-index")] = setTimeout(() => {
        $(e.target).find("span").removeClass("show");
      }, 250);
    },
    getLocal() {
      if (this.$i18n.availableLocales.filter((item) => {
        return item === this.$i18n.locale
      }).length > 0) {
        return this.$i18n.locale;
      } else {
        return this.$i18n.fallbackLocale;
      }
    },
    join() {
      //currentCountryCode
      if (this.currentCountry === '' || this.currentCountryCode === '') {
        return false;
      }
      var local = this.getLocal();
      var countryCode = this.currentCountryCode;
      var countryName = this.currentCountry;
      var countryLanguage = this.currentCountryLanguage;
      _czc.push(["_trackEvent", "CLICK", "JOIN", countryCode, "", ""]);
      this.$emit("complete", {
        local, countryCode, countryName, countryLanguage
      })
    },
    confirmLanguage(item) {
      this.$i18n.locale = item.local;
      this.$cookies.set("i18n", item.local);
      $("title").html(this.$i18n.t("title"));
      this.showLanguage = false;
      //this.join();
    }
    ,
    confirmCountry(item) {
      this.currentCountryCode = item.code;
      this.currentCountry = item.name;
      this.currentCountryLanguage = item.languages;
      this.showCountry = false;
      if (item.languages.length > 1) {
        this.languages = item.languages;
        this.showLanguage = true;
      } else {
        this.confirmLanguage(item.languages[0]);
        //this.join(item.languages[0]);
      }
    },
    selectCountry() {
      this.showCountry = true;
    },
    resize() {
      var appWidth = $("#app").width();
      var appHeight = $("#app").height();
      var mapWidth = 1920;
      var mapHeight = 1080;
      this.maxHeight = appHeight - 284 - 200;

      /*//尝试按宽缩小
      var zoom = appWidth / mapWidth;
      //计算高是否超, 不超就这样,超按高来
      if (mapHeight * zoom > appHeight) {
        zoom = appHeight / mapHeight
      }
      this.scale = zoom;*/

      //尝试按宽缩小
      var zoom = appWidth / mapWidth;
      //计算高是否够, 够就这样,不够再来
      if (mapHeight * zoom < appHeight) {
        zoom = appHeight / mapHeight
      }
      this.scale = zoom;


      /*var appSize = appWidth / appHeight;
      var mapSize = mapWidth / mapHeight;
      this.maxHeight = appHeight - 284 - 200;
      if (appSize <= mapSize) {
        this.scale = $("#app").height() / mapHeight;
        return;
      }

      if (appSize > mapSize) {
        this.scale = $("#app").width() / mapWidth;
        return;
      }*/
    }
  },
  mounted() {
    //去的时间
    //计算缩放
    this.resize();
    //注册事件
    $(window).resize(this.resize);
  },
  beforeDestroy() {
    $(document).unbind("mouseover", this.pointMouesOver);
    $(document).unbind("mouseout", this.pointMouesOut);
    $(window).unbind("resize", this.resize);
  }
  ,
  destroyed() {
    // $(window).unbind(this.resize);
  }
}
</script>

<style scoped>
.point {
  position: absolute;
  width: 11px;
  height: 11px;
  /*background-color: rgba(255, 0, 0, 0.5);*/
}

.point span {
  display: none;
  position: absolute;
  right: 8px;
  opacity: 0;
  transition-duration: 0.2s;
  top: -9px;
  border-radius: 5px;
  background-color: #bc9563;
  padding: 3px 6px;
  white-space: nowrap;
  color: #fff;
}

.point span.show {
  display: block;
}

.point span.ani {
  opacity: 1;
  right: 16px;
}

/*.point:hover span {
  display: block;
}*/

.ns-map {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: #0b194b;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}

.map-c {
  transform-origin: center center;
}

.bottom {
  position: absolute;
  left: 0px;
  bottom: 26px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: flex;
}

.bottom .text {
  color: #ffffff;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 18px;
  font-size: 16px;
}

.bottom .btns {
  align-items: center;
  justify-content: center;
  display: flex;
}

.bottom .btns .item {
  width: 340px;
  height: 50px;
  line-height: 50px;
  margin-left: 9px;
  margin-right: 9px;
}

.bottom .btns .item:last-child a {
  display: block;
  background-color: #bc9563;
  color: #fff;
  border-radius: 8px;
  text-align: center;

  animation-iteration-count: infinite;
  animation-name: scale;
  animation-duration: 1s;
  animation-timing-function: linear;

}

.bottom .btns .item:last-child a.dis {
  background-color: gray;
}

.bottom .btns .item:first-child a {
  display: block;
  background-color: #fff;
  color: #b2854c;
  border-radius: 8px;
  text-align: center;
}

.bottom .btns .item:first-child a span {
  display: block;
  margin-left: 14px;
  margin-right: 14px;
  text-align: left;
  background-image: url(../../../assets/images/map/drop.png);
  background-repeat: no-repeat;
  background-position: right center;
}

.selecter {
  left: 0px;
  top: 0px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
}

.selecter .sc {
  width: 350px;
  color: #fff;
  padding: 20px;
  background-color: #415089;
}

.selecter .sc .title {
  font-size: 18px;
  margin-bottom: 20px;
}

.selecter .sc .list {
  overflow: hidden;
  overflow-y: auto;
}

.selecter .sc .list::-webkit-scrollbar {
  height: 8px;
  width: 2px;
  background: #ccc;
  /*border-radius: 3px;*/
  /*外层轨道*/
}

.selecter .sc .list::-webkit-scrollbar-thumb {
  display: block;
  height: 8px;
  cursor: pointer;
  margin: 0 auto;
  /*border-radius: 10px;*/
  background: #409eff; /*内层轨道*/
}


.selecter .sc .list a {
  display: block;
  font-size: 14px;
  color: #fff;
  background-image: url(../../../assets/images/map/arrow.png);
  background-position: 310px center;
  background-repeat: no-repeat;
  line-height: 45px;
}

.selecter .sc .list a.dis {
  background: none;
}

@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

</style>

